<template>
  <v-container>
    <h1>Lidmaatschap</h1>
    <p class="lg4">
      Om lid te worden van de WOVS dient U het aanvraagformulier voor
      lidmaatschap in te vullen. Vergezeld van een bewijs van inschrijving van
      Uw bedrijf bij de Kamer van Koophandel en Fabrieken .
    </p>
    <p>
      Hierna stuurt de WOVS een bevestiging voor ontvangst en goedkeuring voor
      toelating tot de vereniging. Indien het bedrijf niet voldoet aan de
      toelatingscriteria voor lidmaatschap van de WOVS wordt het niet toegelaten
      tot de vereniging. Conform de bedrijfsactiviteiten wordt het bedrijf
      ingedeeld in één van de sectoren van de WOVS en wordt de jaarlijkse
      contributie vastgesteld.
    </p>
    Voor het effectueren van het lidmaatschap dient u:
    <ul>
      <li>
        Een fotokopie van de brief voor akkoord te ondertekenen en te
        retourneren aan de WOVS.
      </li>
      <li>
        De betaling van de contributie binnen 3 (drie) weken na dagtekening van
        dit schrijven te voldoen.
      </li>
    </ul>

    <v-dialog v-model="dialog" width="680">
      <template v-slot:activator="{ on }">
        <v-btn color="red lighten-2" dark v-on="on">
          Register
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Registratie formulier
        </v-card-title>

        <v-card-text>
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSe-TkSuTsYW7noH1crgpgoWKy6gOrrBqYX4zu1y1OWa4O4BUA/viewform?embedded=true"
            width="640"
            height="2738"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
          >
            Loading…
          </iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "RegistrationPage"
};
</script>
